import { render, staticRenderFns } from "./LKPublicationsFormdataModalContainer.vue?vue&type=template&id=de3e283e&"
import script from "./LKPublicationsFormdataModalContainer.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsFormdataModalContainer.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsFormdataModalContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports